import * as Contexts from 'constants/context';
import {
    ContextWatcher,
    FullscreenContextWatcher,
    DeviceTypeContextWatcher,
    OrientationContextWatcher,
    ViewportWidthContextWatcher,
    ViewportHeightContextWatcher,
    LanguageContextWatcher,
    PlayStateContextWatcher,
    VariablesContextWatcher,
    FormDataContextWatcher,
    ScoreContextWatcher,
    PlayerContextWatcher,
    UserAgentContextWatcher,
    QuizContextWatcher,
    AnnotationContextWatcher,
    LevelContextWatcher
} from './context_watcher';

const CONTEXT_MAP = {
    [Contexts.FULLSCREEN]: FullscreenContextWatcher,
    [Contexts.DEVICE_TYPE]: DeviceTypeContextWatcher,
    [Contexts.ORIENTATION]: OrientationContextWatcher,
    [Contexts.VIEWPORT_WIDTH]: ViewportWidthContextWatcher,
    [Contexts.VIEWPORT_HEIGHT]: ViewportHeightContextWatcher,
    [Contexts.LANGUAGE]: LanguageContextWatcher,
    [Contexts.PLAY_STATE]: PlayStateContextWatcher,
    [Contexts.VARIABLES]: VariablesContextWatcher,
    [Contexts.FORM_DATA]: FormDataContextWatcher,
    [Contexts.SCORE]: ScoreContextWatcher,
    [Contexts.PLAYER]: PlayerContextWatcher,
    [Contexts.USER_AGENT]: UserAgentContextWatcher,
    [Contexts.QUIZ]: QuizContextWatcher,
    [Contexts.ANNOTATION]: AnnotationContextWatcher,
    [Contexts.LEVEL]: LevelContextWatcher
}

export const ContextWatcherFactory = (contextName, initialValue, eventBus) => {
    const Watcher = CONTEXT_MAP[contextName];

    if (Watcher) {
        return new Watcher(initialValue, eventBus);
    }

    throw 'no context handler found';
};